import { useState, useEffect } from "react";
import { Wamp } from "../services/Wamp";

export default function useWamp() {
    const [wamp, setWamp] = useState(null);

    useEffect(() => {
        const unsubOpen = Wamp.instance().subscribe(Wamp.OPEN, () => {
            setWamp(Wamp.instance());
        });

        const unsubClose = Wamp.instance().subscribe(Wamp.CLOSE, () => {
            setWamp(null);
        });

        return () => {
            unsubOpen();
            unsubClose();
        };
    }, []);

    return wamp;
}